import React, { createContext, useContext, useReducer } from "react";
import { initialState, prestacaoContasReducer, PrestacaoContasState } from "./prestacao-contas-reducer";

type PrestacaoContasContextType = {
    state: PrestacaoContasState;
    dispatch: React.Dispatch<any>;
};

const PrestacaoContasContext = createContext<PrestacaoContasContextType | undefined>(undefined);

export const PrestacaoContasProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(prestacaoContasReducer, initialState);

    return (
        <PrestacaoContasContext.Provider value={{ state, dispatch }}>
            {children}
        </PrestacaoContasContext.Provider>
    );
};

export const usePrestacaoContasState = () => {
    const context = useContext(PrestacaoContasContext);
    if (!context) {
        throw new Error("usePrestacaoContasState must be used within PrestacaoContasProvider");
    }
    return context.state;
};

export const usePrestacaoContasDispatch = () => {
    const context = useContext(PrestacaoContasContext);
    if (!context) {
        throw new Error("usePrestacaoContasDispatch must be used within PrestacaoContasProvider");
    }
    return context.dispatch;
};
